import { render, staticRenderFns } from "./ChatScreen.vue?vue&type=template&id=da2127d0&scoped=true&"
import script from "./ChatScreen.vue?vue&type=script&lang=js&"
export * from "./ChatScreen.vue?vue&type=script&lang=js&"
import style0 from "./ChatScreen.vue?vue&type=style&index=0&id=da2127d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2127d0",
  null
  
)

export default component.exports